import * as React from "react";
import * as ReactDOM from "react-dom";
import "@fontsource/roboto";
import "./index.css";
import App from "./App";
import {LicenseInfo} from "@mui/x-data-grid-pro";

LicenseInfo.setLicenseKey("df8cc95257eb79683044a732ac90edfeTz0xMDcyNzUsRT0xNzcwMzM1OTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=");

ReactDOM.render(
    <App />,
    document.getElementById("root") as HTMLElement
);

